import React from 'react'
import LayoutDesktop from '../Layout/Desktop'
import LayoutMobile from '../Layout/Mobile'
import { NavDesktopLoggedOut } from './ContentDesktop'
import { NavMobileLoggedOut } from './ContentMobile'

export type LoggedOutContentProps = {
  site: TODO
  showUpgradeCta: boolean
}

export const LoggedOutContent = ({ site, showUpgradeCta }: LoggedOutContentProps) => {
  const getStartedCta = site?.assets?.startedCta
  const topCitiesLinks = site?.navigation?.footer?.navigationItems
  const loggedOutLinks = site?.navigation?.navigationItems?.navigationItems

  return (
    <>
      <LayoutDesktop>
        <NavDesktopLoggedOut
          links={loggedOutLinks}
          getStartedCta={getStartedCta}
          topCitiesLinks={topCitiesLinks}
        />
      </LayoutDesktop>
      <LayoutMobile showUpgradeCta={showUpgradeCta}>
        <NavMobileLoggedOut links={loggedOutLinks} getStartedCta={getStartedCta} />
      </LayoutMobile>
    </>
  )
}
